<template>
  <div class="subfunds-bankmanage">
    <TagsCloud ref="cloudtage" @cloudTages="cloudTages" />
    <!-- <div class="radiobut" v-if="permission.fdoffunds_audit">
      <el-badge :value="examinelist" class="examine_length">
        <el-radio-group v-model="margintap">

          <el-radio-button label="0">全部子基金</el-radio-button>
          <el-radio-button label="1">审核列表</el-radio-button>
        </el-radio-group>
      </el-badge>
    </div> -->

    <Index @rowdata="rowdata" :files="files" />
    <!-- <Index v-if="margintap == 0" @rowdata="rowdata" :files="files" /> -->
    <!-- <Examinelist v-if="margintap == 1" @rowdata="rowdata" :files="files" @auditlistNub='auditlistNub' /> -->
  </div>
</template>

<script>

import * as api from "@/api/fund/subfunds";
import TagsCloud from "@/components/TagsCloud/TagsCloud";
import Index from "./components/index";
import Examinelist from "./components/examinelist";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      margintap: 0,
      examinelist: 0,
          files: [], 
    };
  },

  components: {
    TagsCloud,
    Index,
    Examinelist,
  },

  computed: {
    ...mapGetters(["permission"]),
  },
  created() {
    this.onLoad();
  },

  methods: {
    onLoad() {
      api
        .getList({
          firstNum: 0,
          num: 10,
          auditState: 1
        })
        .then((res) => {
          
          this.examinelist = res.data.data.total;
          // this.authority = res.data.data.hasAuditRight;
        })
        .catch((res) => {
          console.log(res);
        });
    },
    rowdata(data) {
      this.$refs.cloudtage.save(data);
    },
    cloudTages(data) {
      this.files = data;
    },
    auditlistNub(data){
      
      this.examinelist=data
    },
  },
};
</script>

<style lang="scss" scoped>
.subfunds-bankmanage {
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      // font-weight: bolder;
    }
  }
  .radiobut {
    margin: 25px 0;
  }
  /deep/.el-badge__content{
  line-height: 17px;
    padding: 0 5px;
}
}
</style>

